import type { IPublicUser } from '@sravni/types/lib/auth';

import type AffiliateSummaryModel from '../../models/AffiliateSummaryModel';
import type { GlobalState } from '../index';

export const getUser = (state: GlobalState): IPublicUser | null => (state.user.loggedIn ? state.user.account : null);
export const getAffiliateInfo = (state: GlobalState): AffiliateSummaryModel | null => state.user.affiliateInfo;
